<template>
    <div
        :id="id"
        :aria-labelledby="id"
        class="modal fade pt-popin-cds"
        tabindex="-1"
        role="dialog"
        aria-hidden="true"
        data-ob1-component="Popin"
    >
        <div class="modal-dialog" role="document">
            <div class="modal-content pb-0 px-1 px-md-2">
                <div
                    v-if="radioButtonOfferSelected"
                >
                    <!--/* header */-->
                    <div class="modal-header">
                        <button
                            type="button"
                            class="btn-close pt-2 pt-md-0"
                            data-bs-dismiss="modal"
                            aria-label="Fermer"
                            style="display: block !important"
                        >
                            <span class="icon icon-delete" aria-hidden="true" />
                        </button>
                        <button
                            type="button"
                            class="btn-close ob1-link-arrow back"
                            data-bs-dismiss="modal"
                            style="display: none !important"
                        >
                            Fermer
                        </button>
                    </div>
                    <!--/* content */-->
                    <div class="modal-body px-0">
                        <div class="row">
                            <div class="col-12 px-2 px-md-3 px-lg-5">
                                <!--/* header offre */-->
                                <div class="row">
                                    <div class="col-10">
                                        <strong
                                            v-if="showBanner(radioButtonOfferSelected.banner)"
                                            class="ob1-tag ob1-tag-primary mb-1"
                                        >
                                            {{ radioButtonOfferSelected.banner }}
                                        </strong>
                                        <p class="fw-bold py-0 mb-0">
                                            {{ getTitle(radioButtonOfferSelected.name) }}
                                        </p>
                                        <h1 class="py-0 mb-0">
                                            {{ getSubTitle(radioButtonOfferSelected.name, radioButtonOfferSelected.is5G) }}
                                        </h1>
                                    </div>
                                    <div class="col-2 d-flex justify-content-end">
                                        <img
                                            v-if="radioButtonOfferSelected.is5G"
                                            :src="logo5gSrc"
                                            alt="logo 5G Orange"
                                            class="logo-5g-popin"
                                        >
                                        <img
                                            v-else-if="radioButtonOfferSelected.is5GPlus"
                                            :src="logo5gPlusSrc"
                                            alt="logo 5G+ Orange"
                                            class="logo-5g-popin"
                                        >
                                    </div>
                                </div>
                                <div class="row mb-2">
                                    <div v-if="getNewSubMessage(radioButtonOfferSelected)" class="col-12 text-gray3 fw-bold">
                                        {{ getNewSubMessage(radioButtonOfferSelected) }}
                                    </div>
                                    <div class="col-12">
                                        <div :class="isShowOpenDiscountMessage ? 'my-1 px-1 bg-greige' : 'mb-0'">
                                            <ob1-prix-offre
                                                :price="radioButtonOfferSelected.price.price"
                                                :duration="radioButtonOfferSelected.price.duration"
                                                :initial-price="radioButtonOfferSelected.price.initialPrice"
                                                :show-by-month="radioButtonOfferSelected.price.showByMonth"
                                                :show-from="radioButtonOfferSelected.price.showFrom"
                                                :show-promo-duration="radioButtonOfferSelected.price.showPromoDuration"
                                                :open-discount-message="radioButtonOfferSelected.openDiscountMessage"
                                                :price-details="radioButtonOfferSelected.price.priceDetails"
                                                custom-commitment="pt-0 d-block"
                                                :is-inverse="false"
                                                :is-compact="false"
                                                :show-icon="false"
                                            />
                                        </div>
                                    </div>
                                    <div v-if="radioButtonOfferSelected.claims" class="col-12">
                                        <template v-for="(claim, index) in radioButtonOfferSelected.claims">
                                            <offer-claim-cds :key="index" :claim="claim" />
                                        </template>
                                    </div>

                                    <div
                                        v-if="blockedUnBlockedOffer"
                                        id="version-blocked-selection"
                                    >
                                        <div class="lead pt-2 pb-0">
                                            <strong> {{ radioButtonOfferSelected.miniOfferCdsTypeLabel }} </strong>
                                        </div>
                                        <ob1-radio-button-list
                                            :with-column-layout="true"
                                            :radios-buttons="radioButtonBlockedUnBlockedDTO"
                                            @change="onVersionChange"
                                        />
                                    </div>
                                </div>

                                <!--/* attributs accordion */-->
                                <div class="row mb-4">
                                    <div class="col-12">
                                        <div class="accordion" itemscope="" itemtype="https://schema.org/FAQPage">
                                            <div
                                                v-for="(detailAttribute, attributeIndex) in radioButtonOfferSelected.detailAttributes"
                                                :key="radioButtonOfferSelected.idSeo + attributeIndex"
                                                class="card multi"
                                                itemscope=""
                                                itemprop="mainEntity"
                                                itemtype="https://schema.org/Question"
                                            >
                                                <div class="card-header">
                                                    <button
                                                        :id="'faqQuestion-' + radioButtonOfferSelected.idSeo + attributeIndex"
                                                        class="collapsed"
                                                        data-bs-toggle="collapse"
                                                        :data-bs-target="'#faqAnswer-' + radioButtonOfferSelected.idSeo + attributeIndex"
                                                        :aria-controls="'#faqAnswer-' + radioButtonOfferSelected.idSeo + attributeIndex"
                                                        aria-expanded="false"
                                                        type="button"
                                                    >
                                                        <div class="accordion-card-title">
                                                            <p class="accordion-title mb-0" itemprop="name">
                                                                <span>{{ getTitleDetailAttributes(detailAttribute.titleAttribute) }}</span>
                                                            </p>
                                                            <p class="accordion-icon mb-0" aria-hidden="true" />
                                                        </div>
                                                    </button>
                                                </div>
                                                <div
                                                    :id="'faqAnswer-' + radioButtonOfferSelected.idSeo + attributeIndex"
                                                    class="collapse"
                                                    :aria-labelledby="'faqQuestion-' + radioButtonOfferSelected.idSeo + attributeIndex"
                                                    role="region"
                                                    itemscope=""
                                                    itemprop="acceptedAnswer"
                                                    itemtype="https://schema.org/Answer"
                                                >
                                                    <div class="accordion-card-body standard" itemprop="text" v-html="detailAttribute.textAttribute" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!--/* Mentions légales  */-->
                                <div v-if="radioButtonOfferSelected.legalMentions" class="pb-2">
                                    <ob1-liens-haut-bas
                                        :button-id="radioButtonOfferSelected.legalMentions.title.headerId"
                                        :button-label="radioButtonOfferSelected.legalMentions.title.title"
                                        :collapsed-block-id="radioButtonOfferSelected.idSeo + '-' + radioButtonOfferSelected.legalMentions.title.textId"
                                    >
                                        <div v-for="(mention, index) in radioButtonOfferSelected.legalMentions.mentions" :key="'mentiontext-' + radioButtonOfferSelected.idSeo + '-' + index">
                                            <strong v-if="mention.title">{{ mention.title }}</strong>
                                            <span v-if="mention.text" v-html="mention.text" />
                                        </div>
                                    </ob1-liens-haut-bas>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="sticky-bottom py-2 bg-white modal-footer d-flex justify-content-center">
                        <offer-cta-with-device-popin
                            v-if="radioButtonOfferSelected.addOfferDto"
                            :is-wide="false"
                            :is-primary="true"
                            :label="getCtaLabel(radioButtonOfferSelected)"
                            :offer-name="radioButtonOfferSelected.name"
                            :popin-id="'addOfferWithDevicePopIn-' + radioButtonOfferSelected.idSeo"
                            :popin-ctas-dto="radioButtonOfferSelected.addOfferDto.popinWithDeviceCdsDto"
                            :tracking-category="'overlay_forfait'"
                            :tracking-label="getLabelToTmsFormat(radioButtonOfferSelected.name)"
                            :from-cds="true"
                            :is-sub="isSub"
                        />

                        <offer-cta-with-device-popin
                            v-if="radioButtonOfferSelected.addOfferWithAuthenticationDto"
                            :is-wide="false"
                            :is-primary="true"
                            :label="getCtaLabel(radioButtonOfferSelected)"
                            :offer-name="radioButtonOfferSelected.name"
                            :popin-id="'addOfferWithAuthenticationAndDevicePopIn-' + radioButtonOfferSelected.idSeo"
                            :popin-ctas-dto="radioButtonOfferSelected.addOfferWithAuthenticationDto.popinWithDeviceCdsDto"
                            :tracking-category="'overlay_cta'"
                            :tracking-label="getLabelToTmsFormat(radioButtonOfferSelected.name)"
                            :from-cds="true"
                            :is-sub="isSub"
                        />
                        <ob1-boutons
                            v-if="radioButtonOfferSelected.addOfferInCartDto"
                            class="mx-0 px-0 w-100"
                            :is-button="true"
                            :is-primary="true"
                            :label="radioButtonOfferSelected.addOfferInCartDto.label"
                            data-oevent-category="tuile_forfait_vsim"
                            data-oevent-action="ajouter_au_panier"
                            :data-oevent-label="radioButtonOfferSelected.name"
                            @ob1-boutons-click.prevent="onAddOfferInCart()"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import OfferClaimCds from "./OfferClaimCds.vue";
import OfferCtaWithDevicePopin from "../../../common/offerdetails/OfferCtaWithDevicePopin.vue";

export default {
    components: {
        OfferCtaWithDevicePopin,
        OfferClaimCds
    },
    props: {
        id: {
            type: String,
            required: true,
        },
        offers: {
            type: Array,
            required: true
        },
        isSub: {
            type: Boolean,
            required: true
        },
        logo5gSrc: {
            type: String,
            required: true
        },
        logo5gPlusSrc: {
            type: String,
            required: true
        },
        newSubSeoIds:{
            type: Array,
            required: true
        },
        newSubMessage: {
            type: String,
            required: false,
            default: null
        },
    },
    data() {
        return {
            radioButtonOfferSelected: null
        }
    },
    computed: {
        blockedUnBlockedOffer() {
            return this.getBlockedUnBlockedVersion(this.radioButtonOfferSelected)
        },
        radioButtonBlockedUnBlockedDTO() {
            if (this.blockedUnBlockedOffer) {
                return [
                    {
                        radioButtonDTO: {
                            id: "version-blocked",
                            name: "version",
                            label: "blocked",
                            checked: this.radioButtonOfferSelected.blocked,
                            ariaLabelledBy: "blocked",
                            value: "blocked",
                        },
                        primaryText: this.radioButtonOfferSelected.miniOfferCdsTypeBlocked

                    },
                    {
                        radioButtonDTO: {
                            id: "version-no",
                            name: "version",
                            label: "notBlocked",
                            checked: !this.radioButtonOfferSelected.blocked,
                            ariaLabelledBy: "neuf-label",
                            value: "not blocked"
                        },
                        primaryText: this.radioButtonOfferSelected.miniOfferCdsTypeUnBlocked
                    }
                ]
            } else return []
        },
        isShowOpenDiscountMessage() {
            return this.radioButtonOfferSelected.openDiscountMessage !== undefined
        },
    },
    methods: {
        onAddOfferInCart() {
          this.$emit('add-offer-in-cart', this.radioButtonOfferSelected.idSeo);
        },
        getNewSubMessage(selectedOffer) {
            if (selectedOffer && this.newSubSeoIds.includes(selectedOffer.idSeo)) {
                return this.newSubMessage;
            }
            return null;
        },
        getSubTitle(str, is5G) {
            let strWithOut5G = is5G ? str.substring(str.length-2, 0) : str;
            let match = strWithOut5G.match(/\d+/);
            return strWithOut5G.substring(str.indexOf(match ? parseInt(match[0], 10) : '')).trim();
        },
        getTitle(str) {
            let match = str.match(/\d+/);
            return str.substring(0, str.indexOf(match ? parseInt(match[0], 10) : '')).trim();
        },
        getTitleDetailAttributes(detailAttribute) {
            let splitDetailAttribute = detailAttribute.split(String.fromCharCode(160));
            return (splitDetailAttribute[0]);
        },
        getCtaLabel(offer) {
            return this.isSub ? offer.ctaCdsChoiceOfferAndMobileLabel : offer.ctaCdsChoiceOfferLabel
        },
        getLabelToTmsFormat(label) {
            let blockedUnBlockedLabel = '';
            if (this.radioButtonOfferSelected.blocked !== undefined) {
                blockedUnBlockedLabel = this.radioButtonOfferSelected.blocked ? '_bloque' : '_non_bloque';
            }

            return stripAccents(label).split(' ').join('_') + blockedUnBlockedLabel;
        },

        getBlockedUnBlockedVersion(offer) {
            let unBlockedVersion = offer  && this.offers
                && this.offers.filter(o => o.idSeo === offer.equivalentBlockedOrUnblockedVersionIdSeo)
            return unBlockedVersion && unBlockedVersion.length > 0 ? unBlockedVersion[0] : null
        },
        onVersionChange() {
            this.radioButtonOfferSelected = this.blockedUnBlockedOffer
            let action = this.radioButtonOfferSelected.blocked ? 'version_bloquee' : 'version_non_bloquee';
            let label = stripAccents(this.radioButtonOfferSelected.name).split(' ').join('_');
            Tms.link({category: "overlay_forfait", action: action, label: label});
            this.$emit('change-offer-blocked', this.radioButtonOfferSelected.blocked);

        },
        showBanner(banner) {
            return banner && banner !== '';
        },
    },

}
</script>
<style scoped lang="scss">
@media (max-width: 767px) {
    .pt-popin-cds {
        padding-top: 110px !important;
    }
}
.btn-close::before {
    display: none !important;
}
.modal-dialog .modal-header {
    position: inherit !important;
}
.modal-dialog .modal-header.box-shadow {
    box-shadow: none !important;
}

.logo-5g-popin {
    position: absolute;
    top: 0;
    width: 50px;
}
.label-5g-popin {
    position: relative;
    top: 14px;
    right: 15px;
}

//Une classe ajoutée provisoir pour la partie promo du forfait
.ob1-price .ob1-price-promo-duration {
    display: inline;
}

// correctif accordion border dernier element
.accordion .card.multi:last-child .card-header button {
    border-bottom: 0;
}
.accordion .card.multi:last-child {
    border-bottom: 1px solid #ccc;
}
</style>
